import { composeQuery, Query } from '../models/query';
import { DataResponse, PageableResponse, Subscription } from '../models';
import { ceV2Axios } from './axios';

export const toggleAutoRenew = async (recurlySubscriptionId: number) => (await ceV2Axios.put<boolean>(`/subscriptions/toggle-auto-renewal/${recurlySubscriptionId}`)).data;

export const getSubscriptions = async (...criteria: Query<Subscription>[]) => (
  await ceV2Axios.get<PageableResponse<Subscription>>('/subscriptions', {
    headers: {
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
    },
    params: composeQuery<Subscription>(...criteria),
    data: {},
  })
).data.data;

export const getKseEcomEligible = async () => (await ceV2Axios.get<DataResponse<boolean>>('/subscriptions/kse-ecom-eligible')).data.data;
